import { useEffect, useState } from "react";
import { base } from "../../../constant";

export const useImg = ({ src, source }) => {
  const imageBase =
    !source || source === "CDN"
      ? base.imageBaseUrl
      : source === "carCDN"
      ? base.carImageBase
      : "";
  const [zoom, setzoom] = useState<boolean>(false);
  const [imageSrc, setimageSrc] = useState(imageBase + "/blank.png");

  useEffect(() => {
    if (src?.includes("http")) {
      setimageSrc(src);
    } else {
      setimageSrc(imageBase + src);
    }
  }, [imageBase, src]);

  return {
    zoom,
    setzoom,
    imageSrc,
  };
};
